export default __webpack_public_path__ + "static/media/16th December.ff45594a.png";